(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/result-coupon.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/result-coupon.js');
"use strict";

const {
  ReactPaper: Paper
} = svs.ui;
const {
  useDrawSubscription
} = svs.components.sport.drawsRedux.hooks;
const {
  CouponHolderFallback,
  NetSales
} = svs.components.tipsen.routeResult;
const {
  CouponStatic
} = svs.components.tipsen.couponStatic;
const {
  ResultsDrawSelector,
  ResultSettings
} = svs.components.tipsen.routeResult;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  RenderProvider
} = svs.component.tipsen.renderContext;
const {
  pageTypes
} = svs.component.tipsen.renderContext.constants;
const DrawSubscriberLight = _ref => {
  let {
    productId,
    drawNumber
  } = _ref;
  useDrawSubscription(drawNumber, productId, {
    isLightUpdate: true
  });
  return null;
};
const ResultCoupon = _ref2 => {
  let {
    currentDateDraws,
    isLoadingFetchDate,
    draw,
    drawResults
  } = _ref2;
  if (isLoadingFetchDate) {
    return React.createElement(Paper, {
      branding: "sport",
      className: "result-coupon"
    }, React.createElement(CouponHolderFallback, null));
  }
  const renderCoupon = () => {
    if (!draw || !drawResults) {
      return React.createElement(CouponHolderFallback, null);
    }
    const [,,, drawIsCancelled] = drawResults;
    return React.createElement(React.Fragment, null, drawIsCancelled && React.createElement("h1", {
      className: "drawIsCancelled-text"
    }, "Inst\xE4lld omg\xE5ng"), React.createElement(DrawSubscriberLight, {
      drawNumber: draw.drawNumber,
      productId: draw.productId
    }), React.createElement(CouponStatic, {
      alwaysIncludeParams: true,
      drawEvents: draw.drawEvents,
      drawIsCancelled: drawIsCancelled,
      drawNumber: draw.drawNumber,
      drawResults: drawResults[0],
      productId: draw.productId,
      sportType: draw.sportType
    }), React.createElement(NetSales, {
      currencyCounterUniqueId: draw.drawNumber,
      currentNetSale: draw.currentNetSale,
      drawIsCancelled: drawIsCancelled
      ,
      key: draw.drawNumber
    }), (draw === null || draw === void 0 ? void 0 : draw.regCloseTime) && React.createElement("div", {
      className: "pg_result_betstop f-550"
    }, "Spelstopp ".concat(formatDate(draw.regCloseTime, true, true, false))));
  };
  return React.createElement(RenderProvider, {
    pageType: pageTypes.RESULT
  }, React.createElement(ResultSettings, null), React.createElement(Paper, {
    branding: "sport",
    className: "result-coupon"
  }, React.createElement(ResultsDrawSelector, {
    draws: currentDateDraws,
    selectedDraw: "".concat(draw === null || draw === void 0 ? void 0 : draw.drawNumber, "-").concat(draw === null || draw === void 0 ? void 0 : draw.productId)
  }), renderCoupon()));
};
setGlobal('svs.components.tipsen.routeResult.ResultCoupon', ResultCoupon);

 })(window);